module.exports = __webpack_public_path__ + "img/Vector Smart Object1 (Double Click to Edit).d09abaad.svg";